import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSectionA } from '../components/sections/ProblemSectionA';
import { CostComparisonSection } from '../components/sections/CostComparisonSection';
import { CaseStudiesSection } from '../components/sections/CaseStudiesSection';
import { FunnelSection } from '../components/sections/FunnelSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { RevenueProjectionSection } from '../components/sections/RevenueProjectionSection';
import { RepsOverTimeSection } from '../components/sections/RepsOverTimeSection';
import { RecruitingCostCalculator } from '../components/sections/RecruitingCostCalculator';
import { AuthoritySection } from '../components/sections/AuthoritySection';
import { ObjectionSection } from '../components/sections/ObjectionSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { FooterSection } from '../components/sections/FooterSection';
export function LandingPage() {
  return <div className="w-full min-h-screen font-sans" data-id="element-815">
      <HeroSection data-id="element-816" />
      <ProblemSectionA data-id="element-817" />
      <CostComparisonSection data-id="element-818" />
      <CaseStudiesSection data-id="element-819" />
      <FunnelSection data-id="element-820" />
      <HowItWorksSection data-id="element-821" />
      <RevenueProjectionSection data-id="element-822" />
      <RepsOverTimeSection data-id="element-823" />
      <RecruitingCostCalculator data-id="element-824" />
      <AuthoritySection data-id="element-825" />
      <ObjectionSection data-id="element-826" />
      <GuaranteeSection data-id="element-827" />
      <FooterSection data-id="element-828" />
    </div>;
}